import { create } from "zustand";

interface ServiceDrawerState {
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
  syncAddress: number;
  setSyncAddress: (i: number) => void;
  allAddress: ClientAddressType[];
  setAddress: (data: ClientAddressType[]) => void;
}

export interface ClientAddressType {
  id: number;
  nickname: string;
  person_name: string;
  company_name: string;
  mobile_number: string;
  email: string;
  address: string;
  postal_code: string;
  city: string;
  state: string;
}

export const usePickupAddress = create<ServiceDrawerState>((set) => ({
  syncAddress: 0,
  allAddress: [],
  isOpen: false,
  onOpen: () => set({ isOpen: true }),
  onClose: () => set({ isOpen: false }),
  setAddress: (data: ClientAddressType[]) => set({ allAddress: data }),
  setSyncAddress: (syncAddress: number) =>
    set({ syncAddress: syncAddress + 1 }),
}));
